import { ISidebarConfig, ISidebarSection } from '../components/sidebar-menu/sidebar-menu.interface';
import { BASE_SIDEBAR_SECTION } from './base.config';

/**
 * Configuração de sidebar para POST_RESIDENT e POST_SUPERVISOR
 * Acesso limitado: Perfil, Rondas (visualização) e Pânico
 */
export const POST_RESIDENT_SIDEBAR_SECTION: ISidebarSection = {
    id: 'surveillance',
    title: 'Vigilância',
    items: [
        {
            id: 'patrol',
            title: 'Rondas',
            route: '/ronda',
            icon: 'patrol',
            isVisible: true,
        },
        {
            id: 'panic',
            title: 'Acionar Pânico',
            route: '/panico',
            icon: 'alert',
            isVisible: true,
        },
        {
            id: 'panic-events',
            title: 'Eventos de Pânico',
            route: '/eventos-panico',
            icon: 'alert',
            isVisible: true,
        },
    ],
    isVisible: true,
};

export const POST_RESIDENT_SIDEBAR_CONFIG: ISidebarConfig = {
    role: 'POST_RESIDENT',
    sections: [BASE_SIDEBAR_SECTION, POST_RESIDENT_SIDEBAR_SECTION],
};

export const POST_SUPERVISOR_SIDEBAR_CONFIG: ISidebarConfig = {
    role: 'POST_SUPERVISOR',
    sections: [BASE_SIDEBAR_SECTION, POST_RESIDENT_SIDEBAR_SECTION],
};

